<script setup lang="ts">
  const projectStore = useProjectStore()

  function closeDrawer() {
    projectStore.toggleDrawerType(null)
  }
</script>

<template>
  <div class="d-flex flex-row justify-space-between align-start">
    <div class="d-flex justify-center align-start flex-column mt-2 mx-3 mb-2 pa-0">
      <div class="d-flex justify-start align-center">
        <h3 class="header-font mr-2">
          <slot></slot>
        </h3>
        <div class="container-gap d-flex">
          <slot name="actions"></slot>
        </div>
      </div>
      <p class="mt-2 subheader">
        <slot name="subheader"></slot>
      </p>
    </div>
    <v-btn class="mr-2" icon variant="text" aria-label="Close" @click.stop.prevent="closeDrawer()">
      <v-icon icon="mdi-close" size="30"></v-icon>
    </v-btn>
  </div>
</template>

<style scoped>
  .container-gap {
    gap: 7px;
  }

  .subheader {
    opacity: 0.6;
    font-size: 16px;
  }
</style>
